import { Component } from 'react';
import Error from './ErrorComponent';
// import { hookSlackError } from '@utility/function/common';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to a slack channel
    try {
      console.log('error', error);
      console.log('error info', errorInfo);
      const message = String(error);
      // hookSlackError(message);
    } catch (e) {
      console.log('Error', e);
    }
  }

  render() {
    if (this.state.hasError) {
      return <Error />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
